import { render, staticRenderFns } from "./IndentPage.vue?vue&type=template&id=b7384d16&scoped=true&"
import script from "./IndentPage.vue?vue&type=script&lang=js&"
export * from "./IndentPage.vue?vue&type=script&lang=js&"
import style0 from "./IndentPage.vue?vue&type=style&index=0&id=b7384d16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7384d16",
  null
  
)

export default component.exports